import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    organizationId: String,
    refreshInterval: { type: Number, default: 2000 },
    classifiedProgressTemplate: { type: String, default: "Classified {classified} of {total} items..." },
    completedTemplate: { type: String, default: "Completed! Classified {classified} transactions." },
    failedDefault: { type: String, default: "AI classification failed" }
  }

  connect() {
    if (this.element.dataset.running === "true") {
      this.startPolling()
    }
  }

  disconnect() {
    this.stopPolling()
  }

  startPolling() {
    this.poll()
    this.intervalId = setInterval(() => this.poll(), this.refreshIntervalValue)
  }

  stopPolling() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
      this.intervalId = null
    }
  }

  async poll() {
    try {
      const response = await fetch(`/movements/auto_classification`)
      const data = await response.json()

      this.updateProgress(data)

      if (data.status === "completed") {
        this.stopPolling()
        this.showCompletion(data)
        setTimeout(() => window.location.reload(), 1500)
      } else if (data.status === "failed") {
        this.stopPolling()
        this.showError(data.error || this.failedDefaultValue)
      }
    } catch (error) {
      console.error("Failed to fetch AI classification progress:", error)
    }
  }

  updateProgress(data) {
    if (data.total > 0) {
      const progress = Math.round((data.classified / data.total) * 100)
      const progressBar = this.element.querySelector("[data-progress-bar]")
      const progressText = this.element.querySelector("[data-progress-text]")

      if (progressBar) {
        progressBar.style.width = `${progress}%`
      }
      if (progressText) {
        progressText.textContent = this.classifiedProgressTemplateValue
          .replace("{classified}", data.classified)
          .replace("{total}", data.total)
      }
    }
  }

  showCompletion(data) {
    const progressText = this.element.querySelector("[data-progress-text]")
    if (progressText) {
      progressText.textContent = this.completedTemplateValue
        .replace("{classified}", data.classified)
    }

    const progressBar = this.element.querySelector("[data-progress-bar]")
    if (progressBar) {
      progressBar.classList.remove("bg-indigo-600")
      progressBar.classList.add("bg-green-500")
    }
  }

  showError(message) {
    const progressText = this.element.querySelector("[data-progress-text]")
    if (progressText) {
      progressText.textContent = `Error: ${message}`
      progressText.classList.add("text-red-600")
    }

    const progressBar = this.element.querySelector("[data-progress-bar]")
    if (progressBar) {
      progressBar.classList.remove("bg-indigo-600")
      progressBar.classList.add("bg-red-500")
    }
  }
}
